import { createDivIn, createHeaderIn, createParagraphIn, createImgIn, setElementInnerHTML, setElementOnClick } from '../ui_utils/DomUtils.ts';
import { KeyBindController, ShortcutLocation } from '../KeyBindController.ts';
import { UIPopupManager } from './UIPopupManager.ts';
import { LobbyImage } from '@colonist/types';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { hideTooltip } from '../ui_utils/TooltipUtils.ts';
import { AudioManager, AudioType } from '@colonist/audio';
/** @deprecated Build new popups with the React `Dialog` component from `@colonist/ui` instead. */ export class ViewPopup {
    makeLarge() {
        this.body.className = 'popup-body-large';
        this.contentContainer.className = 'popup-content-large';
    }
    changeCheckButtonText(text) {
        setElementInnerHTML(this.checkButton, text);
        this.checkButton.className = 'btn_general';
    }
    disableCheckButton() {
        this.checkButton.style.opacity = '0.5';
        this.checkButton.style.pointerEvents = 'none';
    }
    enableCheckButton() {
        this.checkButton.style.opacity = '1.0';
        this.checkButton.style.pointerEvents = 'auto';
    }
    changeXButtonText(text) {
        setElementInnerHTML(this.xButton, text);
        this.xButton.classList.remove('btn_general_x');
    }
    isRemoved() {
        return this.container.style.display == 'none';
    }
    show() {
        this.container.style.display = 'block';
        hideTooltip();
    }
    removePopup() {
        this.removeAction();
        this.container.style.display = 'none';
        if (this.container.parentElement != undefined) this.container.parentElement.removeChild(this.container);
        UIPopupManager.untrackPopup(this);
    }
    isPopupRemoved() {
        return !UIPopupManager.isPopupTracked(this);
    }
    setCancel() {
        this.container.addEventListener('touchend', (touchEndEvent)=>{
            if (this.preventClicksOutsideOfPopupFromClosingPopup) return;
            const touchEndedOutside = touchEndEvent.target == this.container;
            if (!touchEndedOutside) return;
            touchEndEvent.preventDefault();
            this.removePopup();
        });
        if (UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return;
        if (UIUtilsEjsVariables.isUserOnDiscordMobile) return;
        let clickStartedOutside = false;
        window.addEventListener('pointerdown', (pointerDownEvent)=>{
            if (this.preventClicksOutsideOfPopupFromClosingPopup) return;
            clickStartedOutside = pointerDownEvent.target == this.container;
        });
        window.addEventListener('pointerup', (pointerUpEvent)=>{
            if (!clickStartedOutside) return;
            const clickEndedOutside = pointerUpEvent.target == this.container;
            if (!clickEndedOutside) return;
            this.removePopup();
        });
        this.setEscapeKeyBind();
    }
    removeCheckButton() {
        this.checkButton.remove();
    }
    removeXButton() {
        this.xButton.remove();
    }
    setEscapeKeyBind() {
        if (this.preventClicksOutsideOfPopupFromClosingPopup) return;
        KeyBindController.bindKey('Escape', ()=>this.removePopup(), ()=>!this.isRemoved(), ShortcutLocation.General);
    }
    removeFooter() {
        this.footer.style.display = 'none';
        this.body.style.border = '0px';
    }
    applyOptions(options) {
        var _options_backButton;
        if (options == undefined) return;
        if (options.showXButton === false) this.removeXButton();
        if (options.showCheckButton === false) this.removeCheckButton();
        if (options.showXonHeader === true) this.addXOnHeader();
        if (((_options_backButton = options.backButton) === null || _options_backButton === void 0 ? void 0 : _options_backButton.showBackButton) === true) this.addBackButton();
        if (options.xButtonCustomContent != undefined) {
            this.xButton.classList.remove('btn_general_x');
            setElementInnerHTML(this.xButton, options.xButtonCustomContent);
        }
        if (options.checkButtonCustomContent != undefined) {
            this.checkButton.classList.remove('btn_general_check');
            setElementInnerHTML(this.checkButton, options.checkButtonCustomContent);
        }
    }
    addXOnHeader() {
        const cancelElement = createImgIn(this.header, LobbyImage.XMark, 'popup-close');
        setElementOnClick(cancelElement, ()=>{
            AudioManager.play(AudioType.Click);
            this.removePopup();
        });
    }
    addBackButton() {
        const backElement = createImgIn(this.header, LobbyImage.LeftArrow, 'popup-back');
        setElementOnClick(backElement, ()=>{
            var _this_options_backButton_backButtonAction, _this_options_backButton, _this_options;
            AudioManager.play(AudioType.Click);
            (_this_options = this.options) === null || _this_options === void 0 ? void 0 : (_this_options_backButton = _this_options.backButton) === null || _this_options_backButton === void 0 ? void 0 : (_this_options_backButton_backButtonAction = _this_options_backButton.backButtonAction) === null || _this_options_backButton_backButtonAction === void 0 ? void 0 : _this_options_backButton_backButtonAction.call(_this_options_backButton);
        });
    }
    addBodyContent(content) {
        createParagraphIn(this.body, content, '');
    }
    setFocusStyles(inputElement, shouldScrollIntoView = false) {
        if (!UIUtilsEjsVariables.isUserOnDiscordMobile) return;
        inputElement.addEventListener('focus', ()=>{
            this.container.classList.add('popup-focus-mobile');
            if (!shouldScrollIntoView) return;
            setTimeout(()=>{
                inputElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }, 100);
        });
        inputElement.addEventListener('focusout', ()=>{
            this.container.classList.remove('popup-focus-mobile');
        });
    }
    constructor(title, body, checkAction, xAction, canCancel, options){
        this.removeAction = ()=>undefined;
        this.container = createDivIn(document.body, 'popup');
        this.contentContainer = createDivIn(this.container, 'popup-content');
        this.header = createDivIn(this.contentContainer, 'popup-header');
        this.body = createDivIn(this.contentContainer, 'popup-body');
        this.footer = createDivIn(this.contentContainer, 'popup-footer');
        this.options = options;
        this.xButton = createDivIn(this.footer, 'btn_general btn_general_secondary btn_general_x');
        setElementOnClick(this.xButton, ()=>{
            AudioManager.play(AudioType.Click);
            xAction();
            this.removePopup();
        });
        this.checkButton = createDivIn(this.footer, 'btn_general btn_general_check');
        setElementOnClick(this.checkButton, ()=>{
            AudioManager.play(AudioType.Click);
            checkAction();
            this.removePopup();
        });
        this.preventClicksOutsideOfPopupFromClosingPopup = false;
        if (canCancel) this.setCancel();
        this.headerTitle = createHeaderIn(this.header, title, '', '', 'H2');
        if (body != undefined) createParagraphIn(this.body, body, '');
        this.applyOptions(options);
        UIPopupManager.trackPopup(this);
    }
}
